import { createFileRoute, redirect } from '@tanstack/react-router'
import { LoginPage } from '@/components/auth/login-page'
import { isConfigured } from '@/lib/env'
import { supabase } from '@/lib/supabase'

export const Route = createFileRoute('/login')({
  // Plain validator (not zod) so the form library stays out of the start-up bundle.
  validateSearch: (search: Record<string, unknown>): { redirect?: string; reason?: string } => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
    reason: typeof search.reason === 'string' ? search.reason : undefined,
  }),
  beforeLoad: async () => {
    if (!isConfigured) throw redirect({ to: '/setup' })
    const { data } = await supabase.auth.getSession()
    if (data.session) throw redirect({ to: '/' })
  },
  component: LoginPage,
})
